export const validateString = (value: string, minLength: number = 1, maxLength: number = 50): boolean => {
  return value !== undefined && value.length >= minLength && value.length <= maxLength;
};

export const validateNumber = (value: number, minValue: number = 1, maxValue: number = 30): boolean => {
  return value !== undefined && value >= minValue && value <= maxValue;
};